import { makeOptimizationWorkloadLink } from 'features/cluster/workload-optimization/navigation';
import { usePaginatedWorkloadsQuery } from 'hooks/queries/workload-optimization';

import { WorkloadCrossLinks } from './WorkloadCrossLinks';
import { WorkloadDetailsTitle } from './WorkloadDetailsTitle';
import { useCostReportWorkloadRestrictions } from '../_hooks/useCostReportWorkloadRestrictions';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type Props = {
  workloadName: string;
  namespace: string;
  workloadType: string;
};

export const WorkloadDetailsTitleWithActions = ({
  workloadName,
  namespace,
  workloadType,
}: Props) => {
  const { cluster } = useCluster();

  const { workloads } = usePaginatedWorkloadsQuery({
    clusterId: cluster.id,
    workloadNames: [workloadName],
    namespaces: [namespace],
    kinds: [workloadType],
  });

  const matchingWorkload = workloads.at(0);

  const woopLink = matchingWorkload
    ? makeOptimizationWorkloadLink({
        workloadId: matchingWorkload.id,
        clusterId: cluster.id,
      })
    : undefined;

  const restrictionsMatch = useCostReportWorkloadRestrictions({
    workloadName,
    namespace,
    workloadType,
  });

  return (
    <WorkloadDetailsTitle
      workloadName={workloadName}
      woopLink={woopLink}
      actions={
        <WorkloadCrossLinks
          workloadName={workloadName}
          namespace={namespace}
          workloadType={workloadType}
          matchingWorkload={matchingWorkload}
          restrictions={restrictionsMatch.restrictions}
          hasRestrictions={restrictionsMatch.hasRestrictions}
          isRestrictionsLoading={restrictionsMatch.isLoading}
        />
      }
    />
  );
};
